import React from 'react';

import WordPicker from '../Wordpicker';

type InverseWordPickerProps = {
  dependData: Object,
  setAnswer: Function,
  setTip: Function,
  words: Array,
};

const InverseWordPicker = ({
  dependData, setAnswer, setTip, words, ...props
}: InverseWordPickerProps) => {
  const filteredWords = words.filter(word => !dependData.includes(word));
  return (
    <WordPicker
      {...props}
      words={filteredWords}
      setTip={() => { }} // prevent wordpicker to set it's answers as a tip
      setAnswer={(value, isValid) => {
        setAnswer(value, isValid);
        setTip(value[0]);
      }}
    />
  );
};

export default InverseWordPicker;
